import React, { useEffect } from 'react';
import {
  validURL,
  convertTimestamp,
  validCampaign,
  validMedium,
  validSource,
  formatParam,
  addTrailingSlash
} from '../helpers';

export default function UTMBuilder({ formData, curList, updateValue }) {
  const {
    id,
    destinationUrl,
    campaign,
    date,
    medium,
    source,
    content,
    keyword
  } = formData;

  let generatedUTM = `${addTrailingSlash(destinationUrl)}`;

  if (campaign && medium && source) {
    const campaignParam = `?utm_campaign=${encodeURIComponent(
      formatParam(campaign)
    )}`;

    const mediumParam = `&utm_medium=${encodeURIComponent(
      formatParam(medium)
    )}`;

    const sourceParam = `&utm_source=${encodeURIComponent(
      formatParam(source)
    )}`;

    generatedUTM += campaignParam + mediumParam + sourceParam;
  }

  if (date) {
    const dateParam = `${encodeURIComponent(
      '__' + formatParam(convertTimestamp(date))
    )}`;
    generatedUTM += dateParam;
  }

  if (content) {
    const contentParam = `&utm_content=${encodeURIComponent(
      formatParam(content)
    )}`;
    generatedUTM += contentParam;
  }

  if (keyword) {
    const keywordParam = `&utm_term=${encodeURIComponent(
      formatParam(keyword)
    )}`;
    generatedUTM += keywordParam;
  }

  const validateUTM = (utmString) => {
    if (
      !validURL(utmString) ||
      !validCampaign(campaign) ||
      !validMedium(medium) ||
      !validSource(source)
    ) {
      const errorList = [];
      if (!validURL(utmString)) errorList.push('Not a valid Destination URL');
      if (!validCampaign(campaign)) errorList.push('Campaign Required');
      if (!validMedium(medium)) errorList.push('Medium Required');
      if (!validSource(source)) errorList.push('Source Required');
      utmString = `${errorList.join(', ')}`;
    }

    return utmString;
  };

  const updateUTMLink = (id, oldState) => {
    updateValue({ ...formData, utm: generatedUTM });
  };

  useEffect(() => updateUTMLink(id, curList), [generatedUTM]);

  return (
    <div className="grid__col-lg-12 u--padding-0 u--display-flex u--flex u--flex-direction-row u--justify-content-space-between u--align-content-center">
      <div className="u--width-100 u--margin-bottom-5 u--display-flex u--align-content-center u--padding-left-15 u--padding-right-15">
        <span className="utm__builder-label u--display-flex u--justify-content-center u--align-items-center u--font-bold">
          UTM:{' '}
        </span>
        <p className="form__input--lg utm__builder-text u--margin-bottom-0 u--width-100">
          {validateUTM(generatedUTM)}
        </p>
      </div>
    </div>
  );
}
